<template>
  <Card>
    <h1 slot="Title">Funded Program</h1>
    <div slot="MainContent">
      <p>
        The Funded Program master data element is used to control spending related to work orders (WO) and / or projects. 
      </p>
      <p>
        <b>Examples</b>:
      </p>
      <ul class="mb-6">
        <li>
          <ul>
            <li>
              <b>WBS</b>
            </li>
            <li>
              S.00000012
            </li>
          </ul>
        </li>
        <li>
          <ul>
            <li>
              <b>Internal Order </b>
            </li>
            <li>
              4500000001
            </li>
          </ul>
        </li>
        <li>
          <ul>
            <li>
              <b>Cost Center</b>
            </li>
            <li>
              76VV0065
            </li>
          </ul>
        </li>
      </ul>
      <p>
         202011D20 A76VV 131096QLOG 6100.2617 <b><u>WBS, Internal Order or Cost Center</u></b> 1000000067 021001
      </p>
    </div>
    <p><strong>Funded Program&nbsp; </strong></p>
    <p><strong>Note: Refer students to the NOTE:&nbsp; Refer students to the Army Management Structure (Federated ERPs) Guide</strong> <strong>&gt;chapter</strong><strong> 6</strong></p>
    <p><strong>&nbsp;</strong></p>
    <p><strong>FUNDED PROGRAM (</strong><u><strong>WBS, Internal Order, or Cost Center </strong></u><strong>). </strong>&nbsp;The fifth element in the line of accounting is the Funded Program. The Funded Program is used to control spending related to work orders(Reimbursable/Direct work orders) and/or projects. <strong>Funds will be distributed and staged at the generic Funded Program &ldquo;Army&rdquo; until a work order or project has been identified to distribute funds to a detailed funding program.</strong> Once the work order (WO) and/or project is created, the Funded Program is then created using the WO or project number.&nbsp; Then the funds are distributed from ARMY, for example, to the created project/work order.</p>
    <p><strong>INSTRUCTOR NOTE:&nbsp; &nbsp; Ask students,&nbsp; </strong></p>
    <p><strong>Question: What is the purpose of the </strong>Funded Program <strong>?&nbsp; </strong></p>
    <p><strong>Answer: Funded Program is used to control spending related to work orders.</strong></p>
  </Card>
</template>
<style scoped>
ul > li {
  margin-bottom: 0;
}

ul > li > ul {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 500px;
}

ul > li > ul > li {
  width: 100%;
  max-width: 50%;
  margin-bottom: 0;
  list-style-type: none;
  padding-left: 0;
}

</style>
<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'FundedProgram',
  
  data() {
    return {
      Image: require('@/assets/The Basic 6-Digit USSGL Accounts Classification_150ppi.png')
    }
  }
  
}
</script>